export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.386 3.43a1.75 1.75 0 011.229 0l7.648 2.868A.75.75 0 0120.75 7v9.307a1.75 1.75 0 01-1.136 1.639l-7.35 2.756a.75.75 0 01-.527 0l-7.351-2.756a1.75 1.75 0 01-1.136-1.639V7a.75.75 0 01.487-.702l7.649-2.868zm.702 1.404a.25.25 0 00-.176 0L6.136 7 12 9.2 17.864 7l-5.776-2.166zm7.162 3.248l-6.5 2.438v8.398l6.338-2.377a.25.25 0 00.162-.234V8.082zm-8 10.836V10.52l-6.5-2.438v8.225a.25.25 0 00.162.234l6.338 2.377z\" fill=\"#6F7488\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};